const waiverEN = `
<!DOCTYPE html>
<html>
<head>
	<meta http-equiv="content-type" content="text/html; charset=utf-8"/>
	<title></title>
	<meta name="generator" content="LibreOffice 25.2.7.2 (Linux)"/>
	<meta name="author" content="Giffari Arsyad"/>
	<meta name="created" content="2026-01-02T02:01:00"/>
	<meta name="changedby" content="ARIEFIANTO RIZKY"/>
	<meta name="changed" content="2026-01-20T10:51:00"/>
	<meta name="AppVersion" content="16.0000"/>
	<style type="text/css">
		@page { size: 8.5in 11in; margin: 1in }
		p { direction: ltr; margin-bottom: 0.1in; widows: 2; orphans: 2; text-align: left; line-height: 115%; background: transparent }
		h2 { direction: ltr; margin-top: 0.11in; margin-bottom: 0.06in; color: #0f4761; orphans: 2; widows: 2; text-align: left; page-break-inside: avoid; background: transparent; page-break-after: avoid }
		h2.western { font-family: "Aptos Display", serif; font-size: 16pt }
		h2.cjk { font-size: 16pt; font-family:  }
		h2.ctl { font-size: 16pt; font-family:  }
	</style>
</head>
<body lang="en-ID" link="#000080" vlink="#800000" dir="ltr"><p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>DISCLAIMER AND CONSENT OF LIABILITY
(&quot;DOCUMENT&quot;)</b></font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>PLEASE READ THIS DOCUMENT CAREFULLY.</b></font></p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
By agreeing to this Document, I declare that I have read, understood
and agreed to the entire contents of this Document, both for myself
and/or the minor I have registered.</p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
This document applies to PT Dreamus Edutainment Indonesia, including
all shareholders, directors, commissioners, employees, agents,
affiliates, and other parties acting for and on behalf of the
Company, as well as all managed recreational venues, namely SuperPark
Indonesia, Pororo Park Indonesia, and Tayo Station Indonesia
(hereinafter referred to as &quot;<b>PTDEI&quot;).</b></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>CAPACITY AND AUTHORITY</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
By agreeing to this Document, I represent and warrant to PTDEI that:</p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%"><a name="_Hlk217321345"></a>
a. I am at least 18 (eighteen) years old and legally authorized to
give my consent to the entire contents of this Document;</p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%"><a name="_Hlk217321399"></a>
b. I consent to the entire contents of this Document for myself
and/or as a parent or legal guardian of the minor I have registered;
and</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
c. I have full authority to represent and bind the minor to all the
provisions of this Document.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>ASSUMPTIONS AND ACKNOWLEDGMENTS OF ALL RISKS</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">I accept and acknowledge all risks such as but
not limited to trampoline, pedal car, basketball, ninja field, soccer
game, wall climbing, slides and other sports and recreational
activities at PTDEI's premises in Indonesia (collectively, &quot;</font><font color="#333333"><b>PTDEI
Facilities</b></font><font color="#333333">&quot;) which includes the
use, rental or maintenance of any goods or equipment, and the use of,
any PTDEI Facilities,  and any activities, including but not limited
to any training classes, instruction and/or courses (collectively,
&quot;</font><font color="#333333"><b>PTDEI Activities</b></font><font color="#333333">&quot;)
on PTDEI's premises.</font></p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%"><a name="_Hlk217321575"></a>
I understand that the use of PTDEI Facilities and/or participation in
PTDEI Activities (as defined below) may pose a risk of injury,
including but not limited to:</p>
<ul>
	<li><p align="justify" style="margin-top: 0.17in; margin-bottom: 0in; line-height: 115%">
	falls, bruises, or cuts;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	muscle, joint, or bone injury;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	concussion or spinal cord injury;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	physical fatigue or other health problems; and/or</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	serious injury, permanent disability, and death.</p></li>
</ul>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
By agreeing to the entire contents of this Document, I knowingly and
voluntarily:</p>
<ul>
	<li><p align="justify" style="margin-top: 0.17in; margin-bottom: 0in; line-height: 115%">
	accept and assume all risks, especially but not limited to such
	risks;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	understand that such risks are part of recreational activities; and</p></li>
	<li><p align="justify" style="margin-bottom: 0.14in; line-height: 115%">
	declares that participation is made on my own choice and
	responsibility.</p></li>
</ul>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>CORRECT USE OF SERVICES AND FACILITIES</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">I understand and agree that all use of PT DEI
Facilities and/or participation in PTDEI Activities shall be used
responsibly, in accordance with all signs and directives and
instructions from PTDEI and its staff, employees and agents, and in
accordance with my safety, the safety of minors at my own expense and
the safety of others (&quot;</font><font color="#333333"><b>Proper
Use</b></font><font color="#333333">&quot;).</font></p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
I agree to:</p>
<ul>
	<li><p align="justify" style="margin-top: 0.17in; margin-bottom: 0in; line-height: 115%">
	follow all safety instructions and site regulations;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	comply with PTDEI staff instructions; and</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	using the facility safely and responsibly.</p></li>
</ul>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
I understand that violations of the rules may result in the
termination of activities or expenses from the PTDEI area without
refund in accordance with this document.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>PROPERTY AND GOODS</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">I undertake to keep my own belongings at
PTDEI's premises and unconditionally and irrevocably release PTDEI
from any liability for any loss or damage to my property (howsoever
caused) during the use of PTDEI's Facilities and/or participation in
any PTDEI Activities.</font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
For the sake of clarity, I understand that PTDEI is not responsible
for the loss and/or damage to my personal belongings and/or minors
while in PTDEI's area.</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>HEALTH STATEMENT</b></font></p>
<ol>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	I declare that I and/or the minor are in a health condition that
	allows me to participate in activities at PTDEI. By agreeing to the
	entire contents of this Document, I understand that it is the
	responsibility of each visitor to independently assess his/her
	health condition before purchasing a ticket and/or using the
	facility, in particular for visitors with a history or specific
	health condition, including but not limited to heart, lung, asthma,
	epilepsy, respiratory disorders, neurological disorders, or other
	medical conditions that may be affected by physical activity.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	To avoid misunderstandings, good health and condition also includes
	the child's ability to safely participate in a shared play area,
	including the ability to control behavior that has the potential to
	harm oneself or others. Children with special conditions, including
	but not limited to special needs, behavioural disorders, sensory
	impairments, or certain medical conditions, must be under active,
	full, and continuous supervision from a Parent/Guardian at all
	times.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	<font color="#333333">I agree unconditionally and irrevocably, to
	the extent necessary in an emergency to protect my welfare and the
	welfare of the minor in my care, including the administration of
	emergency medical care and ambulance transport.</font></p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	I understand that certain conditions are not permitted to use all or
	part of the facility, including but not limited to pregnancy,
	certain medical conditions, and the use of casts or certain medical
	aids.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	I understand, accept and agree that PTDEI does not provide
	individual supervision, therapy, or special services, and based on
	general operational safety considerations, if deemed to be a risk to
	the safety of myself, other visitors, or any party, in the event of
	any doubt regarding health conditions, it is my responsibility to
	consult with medical personnel before purchasing tickets or using
	PTDEI Facilities and participating in PTDEI Activities.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	In the event of an adverse event, whether compensation for medical
	incidents due to personal conditions or force <i>majeure</i> arising
	directly or indirectly due to such health conditions, PTDEI is not
	responsible for any consequences, losses, or demands that arise, as
	long as the incident is not caused by PTDEI's gross negligence as
	can be legally proven.</p></li>
</ol>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>MAINTENANCE AND SUPERVISION OBLIGATIONS</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">I agree that minors must remain in my care and
supervision while using PT DEI Facilities and/or participating in
PTDEI Activities. I represent and warrant that I am the parent or
legal guardian of a minor in my entourage or have been duly
authorized by a parent or legal guardian and assume the duties and
obligations of a parent or legal guardian over a minor in my
entourage.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">I acknowledge unconditionally and irrevocably
that PTDEI is not responsible for the care and supervision of
unaccompanied minors on PTDEI's premises, which will remain the
responsibility of the parent or legal guardian.</font></p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
I understand and agree that:</p>
<ul>
	<li><p align="justify" style="margin-top: 0.17in; margin-bottom: 0in; line-height: 115%">
	Children under the age of 7 (seven) years must be accompanied by an
	adult;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	PTDEI is not a childcare service; and</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	PTDEI is not responsible for interactions or behaviors between
	visitors, including between minors.</p></li>
</ul>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Any risk or injury arising from the child's actions against
themselves and/or other visitors is the full responsibility of their
respective parents/guardians.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>INDEMNITY</b></font></p>
<p align="justify" style="margin-bottom: 0.17in; line-height: 115%">To
the fullest extent permitted by applicable law, I hereby agree to
indemnify, indemnify, and hold harmless PTDEI, including its
shareholders, directors, commissioners, employees, agents,
affiliates, and other related parties (&quot;<b>Indemnified
Parties</b>&quot;), from and against any and all claims, demands,
losses, liabilities, costs, or expenses (including reasonable legal
fees), arising directly out of: 
</p>
<ol type="a">
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	Any breach or non-compliance by me and/or a minor under my
	responsibility to the provisions of this Document;</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	The acts, omissions, or conduct of me and/or a minor under my
	responsibility, including but not limited to the use of PTDEI
	Facilities and/or participation in PTDEI Activities that are not in
	accordance with regulations, safety instructions, or PTDEI staff
	directives;</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	Injury, loss, or damage caused to third parties or to PTDEI's
	facilities and property caused by the acts or omissions of me and/or
	a minor under my responsibility; and/or</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	Any claim made by or on behalf of a minor who is under my
	responsibility in connection with the use of PTDEI Facilities and/or
	participation in PTDEI Activities.</p></li>
</ol>
<p align="justify" style="margin-bottom: 0.17in; line-height: 115%">This
indemnification provision is not applicable and is not intended to
relieve PTDEI from liability for losses directly caused by gross
negligence or willful misconduct on the part of PTDEI as legally
demonstrable.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>EXEMPTIONS, EXEMPTIONS AND EXEMPTIONS</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">To the fullest extent permitted by law, I
hereby unequivocally, unconditionally and irrevocably agree and on
behalf of any minor listed in my responsibility to waive, waive,
release, discharge any and all claims, demands or demands arising out
of, and the right to sue PTDEI and its shareholders, officers,
directors,  commissioners, employees, agents, insurance companies and
their proxies (collectively, the &quot;</font><font color="#333333"><b>Released
Parties</b></font><font color="#333333">&quot;) of any and all
claims, demands, causes of action, decisions, rights, costs, damages,
debts, liabilities, expenses (including attorney(s) fees), losses and
liabilities of any kind, whether known or not, whether based on
absolute liability, negligence, or otherwise (collectively,
&quot;</font><font color="#333333"><b>Claims</b></font><font color="#333333">&quot;&quot;)
that I may bring against the Released Party arising out of, or in any
way related to my use of PTDEI's Facilities and/or participation in
PTDEI's Activities, unless such Claims are directly proven due to
PTDEI's negligence.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>CONSENT AND ACKNOWLEDGMENT</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">As further set forth in the Fair Use terms, and
with respect for my own safety and the safety of others. I
acknowledge that I may be held solely responsible to others for the
injuries they sustain, if those injuries arose as a result of my
irresponsible, willful, or careless actions. I agree to indemnify all
damages, including but not limited to material and immaterial
damages, incurred in any part of the use of PTDEI Facilities and/or
participation in PTDEI Activities as a result of my irresponsible,
willful, or reckless conduct. If I am responsible for a minor
(whether as a parent, legal guardian, guardian, or otherwise), I
agree to be bound by this Document on behalf of that minor. I am
responsible for the safety of minors and promise to supervise them
directly at all times.</font></p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
I release PTDEI from all claims arising from the use of PTDEI's
Facilities and/or participation in PTDEI's Activities, unless it can
be legally proven that such losses were directly caused by PTDEI's
gross negligence.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>AUTHORIZATION TO USE IMAGES AND PERSONAL
INFORMATION</b></font></p>
<h2 class="western" align="justify" style="page-break-inside: auto; line-height: 115%; page-break-after: auto">
<font color="#000000"><font face="Aptos, serif"><font size="3" style="font-size: 12pt"><b>CCTV
AND SECURITY</b></font></font></font></h2>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
I understand and agree that:</p>
<ul>
	<li><p align="justify" style="margin-top: 0.17in; margin-bottom: 0in; line-height: 115%">
	PTDEI areas are equipped with CCTV systems for security, safety, and
	operational purposes;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	All CCTV recordings are internal and confidential documents
	belonging to PTDEI; and</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	CCTV footage may not be shared, copied, or given to visitors in any
	form without an official written request from the authorized law
	enforcement officials in accordance with applicable laws and
	regulations.</p></li>
</ul>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Under certain circumstances, including for medical purposes or
clarification of incidents, PTDEI may show CCTV footage on a limited
and direct basis through the Park Manager's official device, without
allowing re-recording, taking pictures, or providing copies in any
form to visitors, hospitals, or other parties.</p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Access, viewing, and use of CCTV footage is fully subject to PTDEI's
internal SOPs and written regulations that apply from time to time.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>GENERAL</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">This document is valid forever, for any future
date including today's date, in which I or a registered minor may
visit the premises of PTDEI, and subsequently bind the heirs,
representatives, and successors of the undersigned person and the
minor.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">I will comply with all signs, notices,
directions, instructions or requests of PTDEI, and acknowledge that
PTDEI reserves the right (in its sole discretion) to suspend or
cancel any person's access to PTDEI's Facilities and PTDEI
Activities, without refund or compensation, for non-compliance with
any terms of sale, signs, notices, directives, instructions or
requests of PTDEI, for unsafe, reckless or careless conduct,  to
ensure safety, security or order at PTDEI's premises, or if PTDEI
deems that circumstances require it.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Each provision of this Document shall be
subject to and apply to the fullest extent permitted by law. In the
event of a conflict with the terms of sale, the terms relating to
this Document shall prevail.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Any provision herein held to be invalid,
unenforceable, or unenforceable, shall become ineffective only to the
extent of its invalidity, unenforceability, or unenforceability,
without affecting any other provision herein which shall remain in
full force and effect, and shall be deemed amended as necessary to
give effect as close as possible to the intent and purpose of the
invalid provision,  is not applicable, or cannot be enforced.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">I, for myself and/or for a minor registered as
(or as an authorized agent of) their parents, legal guardians,
guardians, guardians, have carefully read these Exclusions and
Consents, fully understand its terms, and sign them freely and
voluntarily.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">I understand that I, and the registered minors,
have waived substantial rights by signing them, and agree to be bound
by the terms for myself and on behalf of the listed minors.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">I irrevocably agree and expressly agree that
the contents contained in this Document are nothing more than
reasonable and necessary to protect the interests of PT DEI, but if
any such restriction will be deemed void but would be valid if
removed in part or reduced in its application, such restriction shall
apply with such removal or modification as necessary to make such
restriction valid and enforceable.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">By signing this Document, I hereby represent
and warrant to PT DEI that I have all necessary legal powers and
authorities and have obtained all necessary permissions and consents,
including the consent of the spouse and/or the child's parents (as
the case may be), to execute and execute this Document and this
Document is my legal and legally binding obligation,  which can be
implemented in accordance with the provisions.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">This document shall be governed by and
construed in accordance with the laws of Indonesia and the courts of
Indonesia shall have exclusive jurisdiction over any dispute arising
in connection with this Document. If any part of the provisions of
this Document is found to be void or unenforceable under the laws of
Indonesia, the remaining parts shall remain in full force and effect.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<ol>
	<li><h2 class="western" align="justify" style="page-break-inside: auto; margin-bottom: 0.14in; line-height: 115%; page-break-after: auto">
	<font color="#000000"><font face="Aptos, serif"><font size="3" style="font-size: 12pt"><b>OTHER
	TERMS</b></font></font></font></h2></li>
</ol>
<ul>
	<li><p align="justify" style="margin-top: 0.14in; margin-bottom: 0in; line-height: 115%">
	This document is valid for every visit to PTDEI.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	If any provision does not apply, the other provisions remain valid.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	PTDEI reserves the right to stop any activities or deny access to
	anyone for safety.</p></li>
	<li><p align="justify" style="margin-bottom: 0.14in; line-height: 115%">
	This document is subject to the laws of Indonesia.</p></li>
</ul>
<ol start="2">
	<li><h2 class="western" align="justify" style="page-break-inside: auto; margin-top: 0.14in; line-height: 115%; page-break-after: auto"><a name="_brxm8pckby1"></a>
	<font color="#000000"><font face="Aptos, serif"><font size="3" style="font-size: 12pt"><b>STATEMENT
	OF CONSENT</b></font></font></font></h2></li>
</ol>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
By continuing this process, I declare that I have consciously read,
understood and agreed to the entire contents of this Document.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%"><br/>

</p>
</body>
</html>`;

const waiverID = `
<!DOCTYPE html>
<html>
<head>
	<meta http-equiv="content-type" content="text/html; charset=utf-8"/>
	<title></title>
	<meta name="generator" content="LibreOffice 25.2.7.2 (Linux)"/>
	<meta name="author" content="Giffari Arsyad"/>
	<meta name="created" content="2026-01-02T02:01:00"/>
	<meta name="changedby" content="Radika Husaini Ondo"/>
	<meta name="changed" content="2026-01-06T08:49:00"/>
	<meta name="AppVersion" content="16.0000"/>
	<style type="text/css">
		@page { size: 8.5in 11in; margin: 1in }
		p { direction: ltr; margin-bottom: 0.1in; widows: 2; orphans: 2; text-align: left; line-height: 115%; background: transparent }
		h2 { direction: ltr; margin-top: 0.11in; margin-bottom: 0.06in; color: #0f4761; orphans: 2; widows: 2; text-align: left; page-break-inside: avoid; background: transparent; page-break-after: avoid }
		h2.western { font-family: "Aptos Display", serif; font-size: 16pt }
		h2.cjk { font-size: 16pt; font-family:  }
		h2.ctl { font-size: 16pt; font-family:  }
	</style>
</head>
<body lang="en-ID" link="#000080" vlink="#800000" dir="ltr"><p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>PENGECUALIAN DAN PERSETUJUAN TANGGUNG JAWAB
(“DOKUMEN”)</b></font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>HARAP BACA DOKUMEN INI DENGAN BAIK-BAIK.</b></font></p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Dengan menyetujui Dokumen ini, saya menyatakan bahwa saya telah
membaca, memahami, dan menyetujui seluruh isi Dokumen ini, baik untuk
diri saya sendiri dan/atau anak di bawah umur yang saya daftarkan.</p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Dokumen ini berlaku untuk PT Dreamus Edutainment Indonesia, termasuk
seluruh pemegang saham, direksi, komisaris, karyawan, agen, afiliasi,
dan pihak lain yang bertindak untuk dan atas nama perusahaan, serta
seluruh tempat rekreasi yang dikelola, yaitu SuperPark Indonesia,
Pororo Park Indonesia, dan Tayo Station Indonesia (selanjutnya
disebut “<b>PTDEI</b>”).</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>KAPASITAS DAN WEWENANG</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
Dengan menyetujui Dokumen ini, saya menyatakan dan menjamin kepada
PTDEI bahwa:</p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%"><a name="_Hlk217321345"></a>
a. Saya berusia minimal 18 (delapan belas) tahun dan secara hukum
berwenang untuk memberikan persetujuan terhadap seluruh isi Dokumen
ini;</p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%"><a name="_Hlk217321399"></a>
b. Saya memberikan persetujuan terhadap seluruh isi Dokumen ini untuk
diri saya sendiri dan/atau sebagai orang tua atau wali sah dari anak
di bawah umur yang saya daftarkan; dan</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
c. Saya memiliki kewenangan penuh untuk mewakili dan mengikat anak di
bawah umur terhadap seluruh ketentuan dalam Dokumen ini.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>ASUMSI DAN PENGAKUAN ATAS SELURUH RISIKO</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Saya menerima dan mengaku seluruh risiko
seperti namun tidak terbatas pada trampolin, pedal car, bola basket,
lapangan ninja, permainan sepak bola, panjat dinding, perosotan dan
kegiatan olah raga dan rekreasi lainnya di lokasi tempat PTDEI di
Indonesia (secara bersama-sama disebut “</font><font color="#333333"><b>Fasilitas
PTDEI</b></font><font color="#333333">”) yang mencakup penggunaan,
penyewaan atau pemeliharaan barang atau peralatan apa pun, dan
penggunaan, Fasilitas PTDEI apa pun, dan aktivitas apa pun, termasuk
namun tidak terbatas pada kelas pelatihan, instruksi dan/atau kursus
apa pun (secara bersama-sama disebut “</font><font color="#333333"><b>Kegiatan
PTDEI</b></font><font color="#333333">”) di tempat PTDEI.</font></p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%"><a name="_Hlk217321575"></a>
Saya memahami bahwa penggunaan Fasilitas PTDEI dan/atau partisipasi
dalam Kegiatan PTDEI (sebagaimana didefinisikan dibawah) dapat
menimbulkan risiko cedera, termasuk namun tidak terbatas pada:</p>
<ul>
	<li><p align="justify" style="margin-top: 0.17in; margin-bottom: 0in; line-height: 115%">
	terjatuh, memar, atau luka;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	cedera otot, sendi, atau tulang;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	gegar otak atau cedera tulang belakang;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	kelelahan fisik atau gangguan kesehatan lainnya; dan/atau</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	cedera serius, cacat permanen, hingga kematian.</p></li>
</ul>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Dengan menyetujui seluruh isi Dokumen ini, saya secara sadar dan
sukarela:</p>
<ul>
	<li><p align="justify" style="margin-top: 0.17in; margin-bottom: 0in; line-height: 115%">
	menerima dan menanggung segala risiko, terutama namun tidak terbatas
	pada risiko-risiko tersebut;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	memahami bahwa risiko tersebut merupakan bagian dari aktivitas
	rekreasi; dan</p></li>
	<li><p align="justify" style="margin-bottom: 0.14in; line-height: 115%">
	menyatakan bahwa partisipasi dilakukan atas pilihan dan tanggung
	jawab saya sendiri.</p></li>
</ul>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>PENGGUNAAN LAYANAN DAN FASILITAS YANG BENAR</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Saya memahami dan menyetujui bahwa semua
penggunaan Fasilitas PT DEI dan/atau partisipasi dalam Kegiatan PTDEI
harus digunakan secara bertanggung jawab, sesuai dengan semua
tanda-tanda serta arahan dan instruksi dari PTDEI dan staf, karyawan
dan agennya, dan sesuai dengan keselamatan saya, keselamatan anak di
bawah umur yang saya tanggung dan keselamatan orang lain (&quot;</font><font color="#333333"><b>Penggunaan
yang Benar</b></font><font color="#333333">&quot;).</font></p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Saya setuju untuk:</p>
<ul>
	<li><p align="justify" style="margin-top: 0.17in; margin-bottom: 0in; line-height: 115%">
	mengikuti seluruh petunjuk keselamatan dan peraturan lokasi;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	mematuhi instruksi staf PTDEI; dan</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	menggunakan fasilitas secara aman dan bertanggung jawab.</p></li>
</ul>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
Saya memahami bahwa pelanggaran terhadap aturan dapat mengakibatkan
penghentian aktivitas atau pengeluaran dari area PTDEI tanpa
pengembalian dana sesuai dengan dokumen ini.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>PROPERTI DAN BARANG</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Saya berjanji untuk menjaga barang-barang saya
sendiri di tempat PTDEI dan tanpa syarat dan tidak dapat ditarik
kembali melepaskan PTDEI dari tanggung jawab apa pun atas kehilangan
atau kerusakan apa pun pada harta benda saya (apa pun penyebabnya)
selama pengunaan Fasilitas PTDEI dan/atau partisipasi dalam Kegiatan
PTDEI apa pun.</font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
Demi kejelasan, saya memahami bahwa PTDEI tidak bertanggung jawab
atas kehilangan dan atau kerusakan barang pribadi saya dan/atau anak
di bawah umur selama berada di area PTDEI.</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>PERNYATAAN KESEHATAN</b></font></p>
<ol>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	Saya menyatakan bahwa saya dan/atau anak di bawah umur berada dalam
	kondisi kesehatan yang memungkinkan untuk mengikuti aktivitas di
	PTDEI. Dengan menyetujui seluruh isi Dokumen ini, saya memahami
	bahwa setiap pengunjung bertanggung jawab untuk menilai kondisi
	kesehatannya secara mandiri sebelum membeli tiket dan/atau
	menggunakan fasilitas, khususnya bagi pengunjung dengan riwayat atau
	kondisi kesehatan tertentu, termasuk namun tidak terbatas pada
	penyakit jantung, paru-paru, asma, epilepsi, gangguan pernapasan,
	gangguan neurologis, atau kondisi medis lain yang dapat terpengaruh
	oleh aktivitas fisik.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	Untuk menghindari kesalahpahaman, kesehatan dan kondisi yang baik
	juga mencakup kemampuan anak untuk berpartisipasi secara aman di
	area bermain bersama, termasuk kemampuan mengendalikan perilaku yang
	berpotensi membahayakan diri sendiri atau orang lain. Anak dengan
	kondisi khusus, termasuk namun tidak terbatas pada kebutuhan khusus,
	gangguan perilaku, gangguan sensorik, atau kondisi medis tertentu,
	wajib berada dalam pengawasan aktif, penuh, dan terus-menerus dari
	Orang Tua/Wali setiap saat.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	<font color="#333333">Saya setuju tanpa syarat dan tidak dapat
	ditarik kembali, sepanjang diperlukan dalam keadaan darurat untuk
	melindungi kesejahteraan saya dan kesejahteraan anak dibawah umur
	dalam tanggungan saya, termasuk administrasi perawatan medis darurat
	dan transportasi ambulans.</font></p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	Saya memahami bahwa beberapa kondisi tertentu tidak diperkenankan
	menggunakan seluruh atau sebagian fasilitas, termasuk namun tidak
	terbatas pada kehamilan, kondisi medis tertentu, serta penggunaan
	gips atau alat bantu medis tertentu.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	Saya memahami, menerima dan menyetujui bahwa PTDEI tidak menyediakan
	pengawasan individual, terapi, atau layanan khusus, dan berdasarkan
	pertimbangan keselamatan operasional secara umum, jika dinilai
	berisiko terhadap keselamatan diri sendiri, pengunjung lain, atau
	pihak mana pun, apabila terdapat keraguan mengenai kondisi
	kesehatan, saya bertanggung jawab untuk berkonsultasi dengan tenaga
	medis sebelum membeli tiket atau menggunakan Fasilitas PTDEI dan
	partisipasi dalam Kegiatan PTDEI.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
	Dalam hal terjadi kejadian yang merugikan, baik ganti ruginsiden
	medis akibat kondisi pribadi atau keadaan memaksa (<i>force majeure</i>)
	yang timbul secara langsung maupun tidak langsung akibat kondisi
	kesehatan tersebut, PTDEI tidak bertanggung jawab atas segala
	akibat, kerugian, atau tuntutan yang timbul, sepanjang kejadian
	tersebut tidak disebabkan oleh kelalaian berat PTDEI sebagaimana
	dapat dibuktikan secara hukum.</p></li>
</ol>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>KEWAJIBAN PERAWATAN DAN PENGAWASAN</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Saya setuju bahwa anak dibawah umur harus tetap
berada dalam perawatan dan pengawasan saya saat menggunakan Fasilitas
PT DEI dan/atau partisipasi dalam Kegiatan PTDEI. Saya menyatakan dan
menjamin bahwa saya adalah orang tua atau wali yang sah dari anak
dibawah umur di rombongan saya atau telah diberi wewenang yang sah
oleh orang tua atau wali yang sah dan memikul tugas dan kewajiban
orang tua atau wali yang sah atas anak dibawah umur di rombongan
saya.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Saya mengakui tanpa syarat dan tidak dapat
ditarik kembali bahwa PTDEI tidak bertanggung jawab atas perawatan
dan pengawasan anak dibawah umur yang tidak didampingi di tempat
PTDEI, yang akan tetap menjadi tanggung jawab orang tua atau wali
yang sah.</font></p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Saya memahami dan menyetujui bahwa:</p>
<ul>
	<li><p align="justify" style="margin-top: 0.17in; margin-bottom: 0in; line-height: 115%">
	Anak di bawah usia 7 (tujuh) tahun wajib didampingi oleh orang
	dewasa;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	PTDEI bukan layanan penitipan anak; dan</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	PTDEI tidak bertanggung jawab atas interaksi atau perilaku antar
	pengunjung, termasuk antar anak di bawah umur.</p></li>
</ul>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Segala risiko atau cedera yang timbul akibat tindakan anak terhadap
diri sendiri dan atau pengunjung lain merupakan tanggung jawab penuh
orang tua/wali masing-masing.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>GANTI RUGI</b></font></p>
<p align="justify" style="margin-bottom: 0.17in; line-height: 115%">Sejauh
diizinkan oleh hukum yang berlaku, saya dengan ini setuju untuk
membebaskan, mengganti kerugian, dan melindungi PTDEI, termasuk
pemegang saham, direksi, komisaris, karyawan, agen, afiliasi, serta
pihak-pihak terkait lainnya (“<b>Pihak yang Diberi Ganti Rugi</b>”),
dari dan terhadap setiap dan seluruh klaim, tuntutan, kerugian,
tanggung jawab, biaya, atau pengeluaran apa pun (termasuk biaya hukum
yang wajar), yang timbul secara langsung akibat:</p>
<ol type="a">
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	Pelanggaran atau ketidakpatuhan saya dan/atau anak di bawah umur
	yang berada dalam tanggung jawab saya terhadap ketentuan dalam
	Dokumen ini;</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	Tindakan, kelalaian, atau perilaku saya dan/atau anak di bawah umur
	yang berada dalam tanggung jawab saya, termasuk namun tidak terbatas
	pada penggunaan Fasilitas PTDEI dan/atau partisipasi dalam Kegiatan
	PTDEI yang tidak sesuai dengan peraturan, instruksi keselamatan,
	atau arahan staf PTDEI;</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	Cedera, kerugian, atau kerusakan yang ditimbulkan kepada pihak
	ketiga atau terhadap fasilitas dan properti PTDEI yang disebabkan
	oleh tindakan atau kelalaian saya dan/atau anak di bawah umur yang
	berada dalam tanggung jawab saya; dan/atau</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	Klaim apa pun yang diajukan oleh atau atas nama anak di bawah umur
	yang berada dalam tanggung jawab saya sehubungan dengan penggunaan
	Fasilitas PTDEI dan/atau partisipasi dalam Kegiatan PTDEI.</p></li>
</ol>
<p align="justify" style="margin-bottom: 0.17in; line-height: 115%">Ketentuan
ganti rugi ini tidak berlaku dan tidak dimaksudkan untuk membebaskan
PTDEI dari tanggung jawab atas kerugian yang secara langsung
disebabkan oleh kelalaian berat atau kesalahan yang disengaja dari
PTDEI sebagaimana dapat dibuktikan secara hukum.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>PENGECUALIAN, PEMBEBASAN DAN PELEPASAN</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Sejauh diizinkan oleh undang-undang, saya
dengan ini secara tegas, tanpa syarat dan tidak dapat ditarik kembali
menyetujui dan atas nama setiap anak dibawah umur yang terdaftar
dalam tanggung jawab saya untuk mengesampingkan, melepaskan,
membebaskan, menyingkirkan setiap dan semua klaim, tuntutan atau
permintaan yang timbul dari, dan hak untuk menuntut PTDEI dan para
pemegang saham, pejabat, direktur, komisaris, karyawan, agen,
perusahaan asuransi dan kuasanya (secara bersama-sama disebut “</font><font color="#333333"><b>Pihak
yang Dibebaskan</b></font><font color="#333333">”) dari setiap dan
seluruh klaim, tuntutan, penyebab tindakan, keputusan, hak, biaya,
kerusakan, hutang, kewajiban, pengeluaran (termasuk biaya
perwakilan(-perwakilan) hukum), kerugian dan tanggung jawab dalam
bentuk apa pun, baik diketahui atau tidak, baik berdasarkan tanggung
jawab mutlak, kelalaian, atau lainnya (secara kolektif disebut
“</font><font color="#333333"><b>Klaim</b></font><font color="#333333">”)
yang mungkin saya ajukan terhadap Pihak yang Dibebaskan yang timbul
dari, atau dengan cara apa pun terkait dengan penggunaan saya atas
Fasilitas PTDEI dan/atau partisipasi dalam Kegiatan PTDEI, kecuali
jika Klaim tersebut terbukti secara langsung karena kelalaian PTDEI.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>PERSETUJUAN DAN PENGAKUAN</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Sebagaimana diatur lebih lanjut dalam ketentuan
Penggunaan yang Benar, dan dengan menghormati keselamatan saya
sendiri dan keselamatan orang lain. Saya mengakui bahwa saya dapat
diminta bertanggung jawab penuh kepada orang lain atas cedera yang
mereka alami, jika cedera tersebut timbul karena tindakan saya yang
tidak bertanggung jawab, disengaja, atau ceroboh. Saya setuju untuk
membayar segala kerugian, termasuk namun tidak terbatas pada kerugian
materil dan immateriil, yang terjadi pada bagian mana pun dari
penggunaan Fasilitas PTDEI dan/atau partisipasi dalam Kegiatan PTDEI
sebagai akibat dari perilaku saya yang tidak bertanggung jawab,
disengaja, atau ceroboh. Jika saya bertanggung jawab atas anak
dibawah umur (baik sebagai orang tua, wali sah, wali, atau lainnya),
saya setuju untuk terikat oleh Dokumen ini atas nama anak dibawah
umur tersebut. Saya bertanggung jawab atas keselamatan anak dibawah
umur dan berjanji untuk mengawasinya secara langsung setiap saat.</font></p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Saya melepaskan PTDEI dari seluruh klaim yang timbul dari penggunaan
Fasilitas PTDEI dan/atau partisipasi dalam Kegiatan PTDEI, kecuali
apabila dapat dibuktikan secara hukum bahwa kerugian tersebut secara
langsung disebabkan oleh kelalaian berat PTDEI.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>OTORISASI UNTUK MENGGUNAKAN GAMBAR DAN
INFORMASI PRIBADI</b></font></p>
<h2 class="western" align="justify" style="page-break-inside: auto; line-height: 115%; page-break-after: auto">
<font color="#000000"><font face="Aptos, serif"><font size="3" style="font-size: 12pt"><b>CCTV
DAN KEAMANAN</b></font></font></font></h2>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Saya memahami dan menyetujui bahwa:</p>
<ul>
	<li><p align="justify" style="margin-top: 0.17in; margin-bottom: 0in; line-height: 115%">
	Area PTDEI dilengkapi dengan sistem CCTV untuk tujuan keamanan,
	keselamatan, dan kepentingan operasional;</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	Seluruh rekaman CCTV merupakan dokumen internal dan bersifat rahasia
	milik PTDEI; dan</p></li>
	<li><p align="justify" style="margin-bottom: 0.17in; line-height: 115%">
	Rekaman CCTV tidak dapat dibagikan, disalin, atau diberikan kepada
	pengunjung dalam bentuk apa pun tanpa permintaan tertulis resmi dari
	aparat penegak hukum yang berwenang sesuai peraturan
	perundang-undangan yang berlaku.</p></li>
</ul>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Dalam kondisi tertentu, termasuk untuk kepentingan medis atau
klarifikasi insiden, PTDEI dapat memperlihatkan rekaman CCTV secara
terbatas dan langsung melalui perangkat resmi Park Manager, tanpa
memperbolehkan perekaman ulang, pengambilan gambar, atau pemberian
salinan dalam bentuk apapun kepada pengunjung, rumah sakit, atau
pihak lain.</p>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Akses, penayangan, dan penggunaan rekaman CCTV sepenuhnya tunduk pada
SOP internal dan regulasi tertulis PTDEI yang berlaku dari waktu ke
waktu.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<font color="#333333"><b>UMUM</b></font></p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Dokumen ini berlaku selamanya, untuk tanggal
apa pun di masa depan termasuk tanggal hari ini, di mana saya atau
anak di bawah umur yang terdaftar dapat mengunjungi tempat PTDEI, dan
selanjutnya mengikat ahli waris, perwakilan, dan penerus dari orang
yang bertanda tangan di bawah ini dan anak di bawah umur.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Saya akan mematuhi semua tanda, pemberitahuan,
arahan, instruksi atau permintaan PTDEI, dan mengakui bahwa PTDEI
berhak (dalam kebijaksanaan mutlaknya) untuk menangguhkan atau
membatalkan akses siapa pun ke Fasilitas PTDEI dan Kegiatan PTDEI,
tanpa pengembalian dana atau kompensasi, atas ketidakpatuhan terhadap
ketentuan penjualan, tanda, pemberitahuan, arahan, instruksi atau
permintaan PTDEI, atas perilaku yang tidak aman, sembrono atau
ceroboh, untuk menjamin keselamatan, keamanan atau ketertiban di
tempat PTDEI, atau jika PTDEI menganggap bahwa keadaan memang
memerlukannya.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Masing-masing ketentuan Dokumen ini harus
tunduk dan berlaku sejauh diizinkan oleh hukum. Jika terjadi
pertentangan dengan ketentuan penjualan, ketentuan terkait Dokumen
ini yang akan berlaku.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Ketentuan apa pun yang disebutkan di sini yang
dianggap tidak sah, tidak berlaku, atau tidak dapat dilaksanakan,
akan menjadi tidak efektif hanya sepanjang ketidakabsahan,
ketidakberlakuan, atau tidak dapat dilaksanakannya hal tersebut,
tanpa mempengaruhi ketentuan lain di sini yang akan tetap mempunyai
kekuatan dan efek penuh, dan akan dianggap diubah seperlunya untuk
memberikan dampak yang sedekat mungkin dengan maksud dan tujuan
ketentuan yang tidak sah, tidak berlaku, atau tidak dapat
dilaksanakan.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Saya, untuk diri saya sendiri dan/atau untuk
anak di bawah umur yang terdaftar sebagai (atau sebagai agen resmi
dari) orang tua, wali sah, wali mereka, telah membaca dengan cermat
Pengecualian dan Persetujuan ini, memahami sepenuhnya
ketentuan-ketentuannya, dan menandatanganinya dengan bebas dan
sukarela.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Saya memahami bahwa saya, dan anak-anak di
bawah umur yang terdaftar, telah melepaskan hak-hak substansial
dengan menandatanganinya, dan setuju untuk terikat oleh
ketentuan-ketentuannya untuk diri saya sendiri dan atas nama
anak-anak di bawah umur yang terdaftar.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Saya secara tidak dapat ditarik kembali dan
secara tegas menyetujui bahwa isi yang terkandung dalam Dokumen ini
tidak lebih dari wajar dan diperlukan untuk melindungi kepentingan PT
DEI, namun jika ada pembatasan tersebut yang akan dianggap batal
namun akan sah jika dihapus sebagian atau dikurangi penerapannya,
pembatasan tersebut akan berlaku dengan penghapusan atau modifikasi
seperlunya agar pembatasan tersebut sah dan dapat dilaksanakan.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Dengan menandatangani Dokumen ini, saya dengan
ini menyatakan dan menjamin kepada PT DEI bahwa saya mempunyai semua
kuasa dan wewenang hukum yang diperlukan dan telah memperoleh semua
izin dan persetujuan yang diperlukan, termasuk persetujuan pasangan
dan/atau orang tua anak (sesuai keadaannya), bila diperlukan, untuk
mengadakan dan melaksanakan Dokumen ini dan Dokumen ini merupakan
kewajiban saya yang sah dan mengikat secara hukum, yang dapat
dilaksanakan sesuai dengan ketentuannya.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%; background: #ffffff">
<font color="#333333">Dokumen ini akan diatur oleh dan ditafsirkan
sesuai dengan hukum Indonesia dan pengadilan Indonesia mempunyai
yurisdiksi eksklusif atas setiap perselisihan yang timbul sehubungan
dengan Dokumen ini. Jika ada bagian dari ketentuan dalam Dokumen ini
yang ternyata batal atau tidak dapat dilaksanakan menurut hukum
Indonesia, bagian lainnya akan tetap mempunyai kekuatan dan pengaruh
penuh.</font></p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<ol>
	<li><h2 class="western" align="justify" style="page-break-inside: auto; margin-bottom: 0.14in; line-height: 115%; page-break-after: auto">
	<font color="#000000"><font face="Aptos, serif"><font size="3" style="font-size: 12pt"><b>KETENTUAN
	LAINNYA</b></font></font></font></h2></li>
</ol>
<ul>
	<li><p align="justify" style="margin-top: 0.14in; margin-bottom: 0in; line-height: 115%">
	Dokumen ini berlaku untuk setiap kunjungan ke PTDEI.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	Jika ada ketentuan yang tidak berlaku, ketentuan lainnya tetap sah.</p></li>
	<li><p align="justify" style="margin-bottom: 0in; line-height: 115%">
	PTDEI berhak menghentikan aktivitas apapun atau menolak akses kepada
	siapapun demi keselamatan.</p></li>
	<li><p align="justify" style="margin-bottom: 0.14in; line-height: 115%">
	Dokumen ini tunduk pada hukum di Indonesia.</p></li>
</ul>
<ol start="2">
	<li><h2 class="western" align="justify" style="page-break-inside: auto; margin-top: 0.14in; line-height: 115%; page-break-after: auto"><a name="_brxm8pckby1"></a>
	<font color="#000000"><font face="Aptos, serif"><font size="3" style="font-size: 12pt"><b>PERNYATAAN
	PERSETUJUAN</b></font></font></font></h2></li>
</ol>
<p align="justify" style="margin-top: 0.17in; margin-bottom: 0.17in; line-height: 115%">
Dengan melanjutkan proses ini, saya menyatakan bahwa saya telah
membaca, memahami, dan menyetujui seluruh isi Dokumen ini secara
sadar, tanpa paksaan apapun dan sukarela.</p>
<p align="justify" style="line-height: 115%; margin-bottom: 0in; background: #ffffff">
<br/>

</p>
<p align="justify" style="margin-bottom: 0in; line-height: 115%"><br/>

</p>
</body>
</html>`;

export { waiverEN, waiverID };